import UntrackedModel from "../../../common/models/untracked/untrackedModel";
import {RouteHelper} from "../../../common/helpers/routeHelper";
import {IQuickLink} from "../interfaces/quickLinkInterface";

export default class QuickLink extends UntrackedModel implements IQuickLink {
  name: string = '';
  url: string = '';
  quick_link_folder_id: string = '';
  sort_order: number;
  route: number = null;
  instance_object_id: string = null;
  instance_object_type: string = null;
  instance_object: object = null;
  move_to_quick_link_folder_id: string = null;
  link_type: string;
  author_name: string;
  c_at: string;

  get forHref(): string {
    if (!this.route) return this.url;
    if (this.instance_object_id && this.instance_object_type === 'Folder') {
      const query = { folder: this.instance_object_id };
      return RouteHelper.path({route: this.route, query})
    } else if (this.instance_object_id) {
      return RouteHelper.path({route: this.route, modelOrId: this.instance_object_id});
    } else {
      return RouteHelper.path({route: this.route});
    }
  }

  get classKey(): string {
    return "QuickLink";
  }
}
